import React from "react";
import BlogEditPanel from "./BlogEditPanel";

/**
 * Sticky top action bar + collapsible edit panel.
 * Image editing is now handled via per-image modals in BlogPostBody.
 */
const BlogActionBar = ({
  onBack,
  actionMsg,
  // diff toggle
  hasPrior,
  diffLoading,
  showDiff,
  onToggleDiff,
  // edit panel toggle
  showEdit,
  onToggleEdit,
  busy,
  onApprove,
  // BlogEditPanel props — post
  showRegenForm,
  setShowRegenForm,
  regenFeedback,
  setRegenFeedback,
  onRegenerate,
  onFullRegenerate,
  onDelete,
}) => (
  <div className="sticky top-0 z-20 bg-white border-b border-gray-200 shadow-sm">
    <div className="max-w-[860px] mx-auto px-4 py-3 flex items-center gap-3 flex-wrap">
      <button
        onClick={onBack}
        className="text-sm text-gray-500 hover:text-gray-800 flex items-center gap-1 mr-auto"
      >
        ← All posts
      </button>

      {actionMsg && (
        <span className="text-sm text-gray-700 bg-gray-100 px-3 py-1 rounded-full">{actionMsg}</span>
      )}

      {hasPrior && (
        <button
          onClick={onToggleDiff}
          disabled={diffLoading}
          className="px-4 py-2 bg-sky-100 text-sky-700 text-sm font-medium rounded-lg hover:bg-sky-200 disabled:opacity-50"
        >
          {diffLoading ? "Loading…" : showDiff ? "✕ Hide changes" : "📋 View changes"}
        </button>
      )}

      <button
        onClick={onToggleEdit}
        disabled={busy}
        className="px-4 py-2 bg-purple-500 text-white text-sm font-medium rounded-lg hover:bg-purple-600 disabled:opacity-50"
      >
        ✏️ Edit
      </button>

      <button
        onClick={onApprove}
        disabled={busy}
        className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 disabled:opacity-50"
      >
        ✅ Approve &amp; Publish
      </button>
    </div>

    {showEdit && !busy && (
      <BlogEditPanel
        busy={busy}
        showRegenForm={showRegenForm}
        setShowRegenForm={setShowRegenForm}
        regenFeedback={regenFeedback}
        setRegenFeedback={setRegenFeedback}
        onRegenerate={onRegenerate}
        onFullRegenerate={onFullRegenerate}
        onDelete={onDelete}
      />
    )}
  </div>
);

export default BlogActionBar;
